<template>
  <v-layout wrap
            justify-space-between
            xs12 md6>
    <v-flex xs12
            md5>
      <v-menu ref="startDateField"
              :close-on-content-click="false"
              :nudge-right="40"
              v-model="startDateField"
              :return-value.sync="start"
              lazy
              transition="scale-transition"
              offset-y
              full-width>
        <v-text-field slot="activator"
                      :value="startFormatted"
                      :label="$t('global.placeholder.from')"
                      required
                      :rules="startRules"
                      prepend-icon="event"
                      readonly></v-text-field>
        <v-date-picker v-model="start"
                       no-title
                       :first-day-of-week="firstDayOfWeek"
                       color="primary"
                       :max="maximumDate"
                       @input="$refs.startDateField.save(start)"
                       :locale="langSelected.langIso"></v-date-picker>
      </v-menu>
    </v-flex>

    <v-flex xs12
            md5>
      <v-menu ref="endDateField"
              :close-on-content-click="false"
              :nudge-right="40"
              v-model="endDateField"
              :return-value.sync="end"
              lazy
              transition="scale-transition"
              offset-y
              full-width>
        <v-text-field slot="activator"
                      :value="endFormatted"
                      :label="$t('global.placeholder.to')"
                      required
                      :rules="endRules"
                      prepend-icon="event"
                      readonly></v-text-field>
        <v-date-picker v-model="end"
                       no-title
                       :first-day-of-week="firstDayOfWeek"
                       color="primary"
                       :min="minimumDate"
                       @input="$refs.endDateField.save(end)"
                       :locale="langSelected.langIso"></v-date-picker>
      </v-menu>
    </v-flex>
  </v-layout>
</template>
<script>
import moment from 'moment';

const onDatesSelectedEvent = 'on-dates-selected';

export default {
  name: 'VuetifyFromToDateSelector',
  props: ['langSelected', 'propStart', 'propEnd'],
  computed: {
    startFormatted() {
      let result = '';
      if (this.start !== null) {
        result = moment(this.start).format('L');
      }
      return result;
    },
    endFormatted() {
      let result = '';
      if (this.end !== null) {
        result = moment(this.end).format('L');
      }
      return result;
    },
    minimumDate() {
      if (this.start !== null) {
        return moment(this.start).add(1, 'days').format('YYYY-MM-DD');
      }
      return moment().add(1, 'days').format('YYYY-MM-DD');
    },
    maximumDate() {
      if (this.end !== null) {
        return moment(this.end).format('YYYY-MM-DD');
      }
      return '2100-12-31';
    },
    today() {
      return moment().format('YYYY-MM-DD');
    },
    startRules() {
      return [
        v => {
          return !!v || this.$i18n.t('global.validation.required.text');
        }
      ]
    },
    endRules() {
      return [
        v => {
          return !!v || this.$i18n.t('global.validation.required.text');
        }
      ]
    },
    firstDayOfWeek() {
      return moment().day(moment.weekdays(true)[0]).isoWeekday();
    }
  },
  watch: {
    start: function(value) {
      this.$emit(onDatesSelectedEvent, { start: this.start, end: this.end });
    },
    end: function(value) {
      this.$emit(onDatesSelectedEvent, { start: this.start, end: this.end });
    },
    propStart: function(value) {
      this.start = this.propStart;
    },
    propEnd: function(value) {
      this.end = this.propEnd;
    }
  },
  data() {
    return {
      startDateField: false,
      endDateField: false,
      start: null,
      end: null
    };
  },
  created() {
    if (typeof this.propStart !== 'undefined') {
      this.start = this.propStart;
    }
    if (typeof this.propEnd !== 'undefined') {
      this.end = this.propEnd;
    }
  },
  methods: {
    reset() {
      this.start = null;
      this.end = null;
      this.startDateField = false;
      this.endDateField = false;
    }
  }
};
</script>
